'use strict';
function t(e) {
  return e.titleText ? `${e.titleText} ${e.firstName} ${e.lastName}` : `${e.firstName} ${e.lastName}`;
}
export {
  t as getFullName
};
